import { Badge, Button, FormField, Link, SegmentedControl, Table } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Pagination from '@cloudscape-design/components/pagination';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import React, { useEffect, useRef, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiGasStationOffOutline, mdiMagnify } from '@mdi/js';
import Icon from '@mdi/react';
import DRPicker from '../../../../../components/DRPicker';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelMovement from '../../../../../components/extras/SidePanelMovement';
import SelectPaging from '../../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemsMovement } from '../../../../../resources/types';
const _preserve = React.version;

export const OPSFuelMovementsPage = () => {
    const { menu, parameters } = useGlobalState();
    const [type, setType] = useState("");
    const [movement, setMovement] = useState<ItemsMovement>();
    const [movements, setMovements] = useState<ItemsMovement[]>([]);
    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filteringText, setFilteringText] = useState("");
    const mountedRef = useRef(false);

    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");
            if (id) {

                if (!mountedRef.current) {
                    mountedRef.current = true;
                    handleCheckFuel();
                }
                handleGetMovement(parseInt(id))
            } else {
                if (mountedRef.current) {
                    handleCheckFuel();
                }
            }
        };
        window.addEventListener("hashchange", handleHashChange);
        handleHashChange();
        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);



    useEffect(() => {
        //handleCheckFuel();
    }, [parameters]);


    const handleGetMovement = async (id: number) => {
        //if (parameters.startDate && parameters.endDate) {
        if (parameters.startDate && parameters.endDate) {

            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/movement',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idMovement: id,
                        isFuel: true,
                        fuelType: parameters.fuelType,
                        columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName, idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK,obs"
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setMovement(data.movement);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }

        };
    }

    const handleCheckFuel = async () => {
        setMovement(undefined)
        if (parameters && parameters.startDate && parameters.endDate && parameters.fuelType !== "") {
            try {
                setLoading(true)

                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        limit: 1000,
                        isFuel: true,
                        fuelType: parameters.fuelType,
                        dateStart: parameters.startDate,
                        dateEnd: parameters.endDate,
                        orderBy: "receipt",
                        order: "desc",
                        columns: "idMovement,idUser,RUT,accountPlan,ammount,balance,data,dateTransaction,displayName, idAccountPlan,idCharge,receipt,jsonBank,jsonDocuments,jsonMovement,jsonTBK,obs"
                    }),
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setMovements(data.movements);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }
        }
    }
    const filtered: ItemsMovement[] = movements.filter((item) => {

        const normalize = (str: string | undefined | null) =>
            (str || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]/g, "");
        const searchWords = normalize(filteringText).split(/\s+/).filter(Boolean);
        const text = normalize([item.data, item.RUT, item.ammount.toString(), item.displayName, item.idMovement.toString()].join(" "));
        return searchWords.every((word) => text.includes(normalize(word)));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);

    return (
        <CustomAppLayout
            toolsHide
            splitPanelOpen={!!movement}

            onSplitPanelToggle={({ detail }) => {
                !detail.open ? window.location.hash = "ops/fuel/movements" : null;
            }}
            splitPanel={
                <SidePanelMovement movement={movement ?? {}} />
            }

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">
                        <Header actions={<Favorites />} counter={movements.length > 0 ?
                            filtered.length !== movements.length ? `(${filtered.length} de ${movements.length})` : `(${movements.length})` : ""}>
                            Movimientos de combustibles
                        </Header>

                        <SpaceBetween direction='vertical' size='xs'>

                            <Table
                                variant="embedded"
                                //onRowClick={({ detail }) => { setMovement(detail.item); setDetailPanel(true); //console.log(detail.item.jsonDocuments) }}
                                stickyHeader

                                columnDefinitions={[
                                    {
                                        id: "dateTransaction",
                                        header: "Fecha",
                                        cell: item => (

                                            <FormField
                                                label={<Link onClick={() => {
                                                    window.location.hash = `ops/fuel/movements?id=${item.idMovement}`
                                                }}>{item.idMovement}</Link>}
                                                description={item.dateTransaction}
                                            />
                                        ),
                                        width: 120
                                    },
                                    {
                                        id: "number",
                                        header: "Folio",
                                        cell: item => item.receipt,
                                        width: 120
                                    },
                                    {
                                        id: "idUser",
                                        header: "Usuario",
                                        cell: item => (

                                            <FormField
                                                description={item.jsonMovement.registration ?
                                                    item.jsonMovement.registration :
                                                    <Badge color='red'>Anulado</Badge>
                                                }
                                                label={item.displayName}
                                            />
                                        )
                                    },
                                    {
                                        id: "data",
                                        header: "Glosa",
                                        cell: item => (

                                            <FormField
                                                description={item.jsonMovement.registration ?
                                                    `${item.jsonMovement.counterEnd} - ${item.jsonMovement.counterStart} = ${item.jsonMovement.liters} LTS x ${item.jsonMovement.price} = ${item.ammount}`
                                                    : "·"}
                                                label={item.data}
                                            />
                                        )
                                    },
                                    {
                                        id: "charge",
                                        header: "Cargo",
                                        cell: item => (
                                            <FormField
                                                description={
                                                    item.ammount < 0 && item.jsonDocuments?.number ? (
                                                        <Badge color="green">{`F${item.jsonDocuments?.number}`}</Badge>
                                                    ) :
                                                        item.ammount < 0 ?
                                                            <Badge color="blue">Pendiente</Badge> : null
                                                }

                                                label={
                                                    (item.ammount < 0 ?
                                                        item.ammount.toLocaleString('es-CL', {
                                                            style: 'currency',
                                                            currency: 'CLP',
                                                            maximumFractionDigits: 2
                                                        }) : <><Icon path={mdiGasStationOffOutline} size={1} /></>)
                                                }
                                            />
                                        )


                                    },
                                ]}
                                trackBy="idMovement"
                                items={paginated ?? []}
                                empty={
                                    <Box
                                        margin={{ vertical: "xs" }}
                                        textAlign="center"
                                        color="inherit"
                                    >
                                        <SpaceBetween size="m">
                                            <b>Sin movimientos asociados</b>
                                        </SpaceBetween>
                                    </Box>
                                }
                                filter={

                                    <SpaceBetween direction="horizontal" size="xs">
                                        <SegmentedControl
                                            selectedId={parameters.fuelType}
                                            onChange={({ detail }) => {
                                                setParameters({ ...parameters, fuelType: detail.selectedId });
                                            }}
                                            label="Tipo combustible"
                                            options={[
                                                { text: "AVGAS", id: "AVGAS" },
                                                { text: "JP1", id: "JP1" },
                                            ]}
                                        />
                                        <TextFilter

                                            filteringPlaceholder="Filtrar"
                                            filteringText={filteringText}
                                            onChange={({ detail }) => {
                                                setFilteringText(detail.filteringText);
                                                setCurrentPageIndex(1);
                                            }}
                                        />


                                        <DRPicker start={parameters.startDate} end={parameters.endDate}
                                            onConfirm={(startDate: string, endDate: string) => {
                                                const updatedParameters = { ...parameters, startDate: startDate, endDate: endDate, };
                                                setParameters(updatedParameters);
                                            }}
                                        />

                                        {parameters.startDate && parameters.endDate && (<Button style={{ root: btnIconForm }} onClick={handleCheckFuel}><Icon path={mdiMagnify} size={1} /></Button>)}
                                    </SpaceBetween>
                                }
                                pagination={
                                    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                        {filtered.length > parameters.pageSize && (
                                            <Pagination
                                                currentPageIndex={currentPageIndex}
                                                pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                            />
                                        )}

                                        {movements.length > 0 && (
                                            <SelectPaging onSelect={(pageSize) => {
                                                setCurrentPageIndex(1);
                                                setParameters({ ...parameters, pageSize: pageSize });
                                            }} />
                                        )}
                                    </SpaceBetween>
                                }
                            />
                        </SpaceBetween>
                    </SpaceBetween>


                </>
            }
        />
    );
};
